import { render, staticRenderFns } from "./PaymentCompletedMelaregalo.vue?vue&type=template&id=79237ff8"
import script from "./PaymentCompletedMelaregalo.vue?vue&type=script&lang=js"
export * from "./PaymentCompletedMelaregalo.vue?vue&type=script&lang=js"
import style0 from "./PaymentCompletedMelaregalo.vue?vue&type=style&index=0&id=79237ff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports